module.exports = __webpack_public_path__ + "static/media/secretary.99146bc6.jpg";